import { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';

import { Role } from '../types';
import { useAuthContext } from '../hooks';

type RouteConfig = {
  path: string;
  params?: Record<string, string | number>;
};

type RoleRouteResolver = (user: any) => RouteConfig | null;

export type RolesRouteConfig = {
  roleResolvers: Array<{
    roleName: string;
    resolver: RoleRouteResolver;
  }>;
  fallbackRoute: string;
};

type RoleGuardProps = {
  rolesRouteConfig: RolesRouteConfig;
  splashScreen: ReactNode;
};

export default function IndexRouteGuard({ rolesRouteConfig, splashScreen }: RoleGuardProps) {
  const { user, loading } = useAuthContext();

  const matchedResolver = rolesRouteConfig.roleResolvers.find(({ roleName }) =>
    user?.roles?.some((role: Role) => role.name === roleName)
  );

  if (loading) {
    return splashScreen;
  }

  if (matchedResolver) {
    const routeConfig = matchedResolver.resolver(user);
    if (routeConfig) {
      return <Navigate to={routeConfig.path as any} params={routeConfig.params as any} replace />;
    }
  } else {
    // If no role matched, navigate to fallback
    return <Navigate to={rolesRouteConfig.fallbackRoute as any} replace />;
  }
}
